export const Work = [
    {
        id:1,
        name:"React Weather App",
        description:"It is a simplle weather app build with reactjs and open weather Api.",
        tags:["react","react-hooks"],
        
        demo:"https://weather-reactjs-ui.netlify.app/",
        github:"https://github.com/Mrinmax/React-Weather-App"
    },
    {
        id:2,
        name:"Project 2",
        description:"Comming soon...",
        tags:["Amazing"],
        
        demo:"",
        github:""
        
    },
    {
        id:3,
        name:"Project 3",
        description:"Comming soon...",
        tags:["Amazing"],
        
        demo:"",
        github:""
        
    },
    {
        id:4,
        name:"Project 4",
        description:"Comming soon...",
        tags:["Amazing"],
        
        demo:"",
        github:""
        
    },
    {
        id:5,
        name:"Project 5",
        description:"Comming soon...",
        tags:["Amazing"],
        
        demo:"",
        github:""
        
    },
    {
        id:6,
        name:"Project 6",
        description:"Comming soon...",
        tags:["Amazing"],
        
        demo:"",
        github:""
        
    }
    

] 